import {
  OwnUpDropdown,
  OwnUpMenuItem,
  OwnUpTextInputProps,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React, { useMemo } from 'react';

import { NumericFormatProps } from 'react-number-format';
import styled from 'styled-components';

const OptionsInputWrapper = styled.div`
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
`;

export type OptionItem = { value: string | number; title: string };

interface WidgetOptionsInputProps extends NumericFormatProps<OwnUpTextInputProps> {
  label: JSX.Element;
  value: number | string;
  options: OptionItem[];
  onChange: (e: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

export const WidgetOptionsInput: React.FC<WidgetOptionsInputProps> = ({
  label,
  value,
  options,
  onChange
}) => {
  const children = useMemo(
    () =>
      options.map((option) => (
        <OwnUpMenuItem key={option.value} value={`${option.value}`}>
          {option.title}
        </OwnUpMenuItem>
      )),
    [options]
  );

  return (
    <OptionsInputWrapper>
      <OwnUpDropdown labelPosition="outer" value={value} label={label} onChange={onChange}>
        {children}
      </OwnUpDropdown>
    </OptionsInputWrapper>
  );
};
